import { ASSET_ID_TO_PUBLIC_PATH } from './registry.generated';

/**
 * Public URL for an icon (Leaflet innerHTML, static templates).
 * @param {string} assetId
 * @param {string} [publicUrlPrefix] — defaults to process.env.PUBLIC_URL
 */
export function getSelkirkIconUrl(assetId, publicUrlPrefix = process.env.PUBLIC_URL || '') {
  const path = ASSET_ID_TO_PUBLIC_PATH[assetId];
  if (!path) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[SelkirkIcon] Unknown asset id for URL: ${assetId}`);
    }
    return '';
  }
  return `${publicUrlPrefix}${path}`;
}

/**
 * HTML img tag for map popups and divIcon labels.
 */
export function selkirkIconImgHtml(assetId, size = 16, className = '') {
  const src = getSelkirkIconUrl(assetId);
  if (!src) return '';
  const cls = className ? ` class="${className}"` : '';
  return `<img src="${src}" width="${size}" height="${size}" alt="" decoding="async"${cls} />`;
}
